
import React from "react";
import { BlogLayout } from "@/components/layout/BlogLayout";
import { TableOfContents } from "@/components/blog/TableOfContents";
import { PostHeader } from "@/components/blog/PostHeader";
import { PostIntroSection } from "@/components/blog/PostIntroSection";
import { vibeCodingTableOfContents } from "./vibe-coding/tableOfContents";
import { ArticleContent } from "./vibe-coding/ArticleContent";
import { RelatedArticles } from "@/components/blog/RelatedArticles";
import { Breadcrumbs } from "@/components/shared/Breadcrumbs";
import { UpdateDate } from "@/components/shared/UpdateDate";
import vibeCodingImage from "@/assets/blog-vibe-coding.jpg";

export function VibeCodingPost() {
  return (
    <>
      <PostHeader 
        title="Qué es el Vibe Coding y por qué está cambiando las reglas del juego en 2026 | SEOEVOLUTION"
        description="Qué es el vibe coding, cómo funciona en 2026, las mejores herramientas y cómo combinarlo con SEO para lanzar productos digitales posicionados desde el primer día."
        keywords="vibe coding, inteligencia artificial, Lovable, desarrollo sin código, SEO técnico, herramientas IA, no-code 2026"
        author="Ángel Ruz"
        canonicalUrl="https://agenciaseoevolution.com/blog/vibe-coding-2026"
        datePublished="2026-03-28"
      />

      <BlogLayout>
        <article className="py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-seo-darkBlue to-seo-dark opacity-90"></div>
          <div className="container mx-auto px-4 md:px-6 relative z-10">
            <div className="max-w-5xl mx-auto">
              <Breadcrumbs />
              
              <PostIntroSection 
                category="INTELIGENCIA ARTIFICIAL"
                title="Qué es el Vibe Coding y por qué está cambiando las reglas del juego en 2026"
                date="28 Marzo, 2026"
                author="Ángel Ruz"
                imageUrl={vibeCodingImage}
                imageAlt="Vibe coding: editor de código con IA y acento violeta"
                description="Hace dos años, si querías lanzar una aplicación web necesitabas un desarrollador, un presupuesto de cinco cifras y meses de trabajo. Hoy puedes describir lo que quieres en lenguaje natural, pulsar enter y tener un MVP funcionando en horas. Eso es el vibe coding. Y está cambiando quién puede construir negocios digitales."
              />

              <UpdateDate 
                date="Marzo 2026"
                updatesSection={
                  <div>
                    <p className="font-semibold mb-2">Novedades 2026:</p>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      <li>Claude Sonnet y GPT-4o generan apps completas</li>
                      <li>Lovable consolida como líder en vibe coding</li>
                      <li>Coste de lanzar un MVP: desde 100€/mes</li>
                      <li>SEO + vibe coding como ventaja competitiva clave</li>
                    </ul>
                  </div>
                }
              />

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-seo-dark/50 rounded-xl p-6 shadow-lg backdrop-blur-xs">
                  <ArticleContent />
                  <RelatedArticles currentSlug="/vibe-coding-2026" category="Inteligencia Artificial" />
                </div>
                
                <div className="lg:col-span-1">
                  <TableOfContents items={vibeCodingTableOfContents} />
                </div>
              </div>
            </div>
          </div>
        </article>
      </BlogLayout>
    </>
  );
}
